import { render } from "./BgMyticketAvailablePeriod.vue?vue&type=template&id=78741ca0&scoped=true"
import script from "./BgMyticketAvailablePeriod.vue?vue&type=script&lang=js"
export * from "./BgMyticketAvailablePeriod.vue?vue&type=script&lang=js"

import "./BgMyticketAvailablePeriod.vue?vue&type=style&index=0&id=78741ca0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-78741ca0"

export default script